const getBrowseFacetsWithFacetOptionsPerPage = async ({ page, cioClient }) => {
  const params = new URLSearchParams({
    key: cioClient?.options?.apiKey,
    page,
    num_results_per_page: 10,
  });

  const baseUrl = cioClient?.options?.serviceUrl;
  const url = `${baseUrl}/browse/facets_with_options?${params.toString()}`;

  return fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then((response) => response.json());
};

/**
 * Get all browse facets from CIO
 * @param {Object} cioClient - CIO client
 * @returns {Promise<Object>} - CIO browse facets
 */
const getAllCioBrowseFacets = async ({
  cioClient,
  fetchWithFacetOptions = true,
}) => {
  if (!cioClient) {
    throw new Error('CIO client is required');
  }

  if (fetchWithFacetOptions) {
    // fetch 4 pages of browse facets since we currently have 35 facets
    return Promise.all(
      Array.from({ length: 4 }, (_, i) =>
        getBrowseFacetsWithFacetOptionsPerPage({ page: i + 1, cioClient })
      )
    ).then((pages) => {
      return {
        response: {
          facets: pages.flatMap((page) => page?.response?.facets),
          total_num_results: pages[0]?.response?.total_num_results,
        },
      };
    });
  }

  return cioClient.browse.getBrowseFacets({
    page: 1,
    resultsPerPage: 200,
  });
};

export default getAllCioBrowseFacets;
